import { Log } from "~/extensions/utils";
import SHA256 from "crypto-js/sha256";
import SHA512 from "crypto-js/sha512";
import SHA3 from "crypto-js/sha3";
import RIPEMD160 from "crypto-js/ripemd160";
import hmacSHA256 from "crypto-js/hmac-sha256";
import hmacSHA512 from "crypto-js/hmac-sha512";
import hmacSHA3 from "crypto-js/hmac-sha3";
import hmacRIPEMD160 from "crypto-js/hmac-ripemd160";
const log = Log.create("PasswordHash");
const key = "miniminiminiminiminiminiminimini";
const sha256 = (text) => {
    try {
        let hash = SHA256(text);
        return hash.toString();
    }
    catch (ex) {
        log.error(ex);
        throw ex;
    }
};
const sha512 = (text) => {
    try {
        let hash = SHA512(text);
        return hash.toString();
    }
    catch (ex) {
        log.error(ex);
        throw ex;
    }
};
const sha3 = (text) => {
    try {
        let hash = SHA3(text);
        return hash.toString();
    }
    catch (ex) {
        log.error(ex);
        throw ex;
    }
};
const ripemd160 = (text) => {
    try {
        let hash = RIPEMD160(text);
        return hash.toString();
    }
    catch (ex) {
        log.error(ex);
        throw ex;
    }
};
const hmacSha256 = (text) => {
    try {
        let hash = hmacSHA256(text, key);
        return hash.toString();
    }
    catch (ex) {
        log.error(ex);
        throw ex;
    }
};
const hmacSha512 = (text) => {
    try {
        let hash = hmacSHA512(text, key);
        return hash.toString();
    }
    catch (ex) {
        log.error(ex);
        throw ex;
    }
};
const hmacSha3 = (text) => {
    try {
        let hash = hmacSHA3(text, key);
        return hash.toString();
    }
    catch (ex) {
        log.error(ex);
        throw ex;
    }
};
const hmacRipemd160 = (text) => {
    try {
        let hash = hmacRIPEMD160(text, key);
        return hash.toString();
    }
    catch (ex) {
        log.error(ex);
        throw ex;
    }
};
export { sha256, sha512, sha3, ripemd160, hmacSha256, hmacSha512, hmacSha3, hmacRipemd160 };
